import { render, staticRenderFns } from "./CustomersIndividual.vue?vue&type=template&id=dacef3cc&scoped=true"
import script from "./CustomersIndividual.vue?vue&type=script&lang=js"
export * from "./CustomersIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacef3cc",
  null
  
)

export default component.exports